import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/** V2 본문·레거시 문서 본문 모두 태그·클래스로 스타일링 */
export const ProductionVendorRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& section + section, & > div + div': { marginTop: 8 },
  '& table': { ...approvalFormTableStyles(theme), minWidth: 640 },
  '& .text-center': { textAlign: 'center' },
  '& .text-left': { textAlign: 'left' },
  '& .text-right': { textAlign: 'right' },
  '& td.label': {
    textAlign: 'center',
    backgroundColor: theme.palette.grey[50],
  },
  '& .cancel': { textDecoration: 'line-through' },
  // 레거시 문서는 text-danger·textBold, V2 는 changed
  '& .changed, & .text-danger': {
    color: theme.palette.error.main,
    fontWeight: 700,
  },
  // 체크 여부에 따라 기준선이 달라 줄이 어긋나지 않게
  '& .vtpm-item': {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    marginRight: 8,
  },
}));
